/* eslint-disable */
import React, { useState, useEffect } from "react";

const slides = [
  {
    type: "image",
    bg: "https://www.ultra-erp.pro/logos/ecommerce.png",
    title: "Business",
    highlight: "moves fast",
    text: "Stay ahead and make sure your teams have what they need to tackle what's ahead.",
    button: "New arrivals",
  },
  {
    type: "solid",
     bgColor: "var(--color-primary)",
    textBig: "Todo lo que necesitas en un solo proveedor",
  },
  {
    type: "solid",
    bgColor: "#172048",
    textBig: "Todo lo que necesitas en un solo proveedor",
  },
];

export default function HeroBanner() {
  const [index, setIndex] = useState(0);

  const next = () => setIndex((i) => (i + 1) % slides.length);
  const prev = () => setIndex((i) => (i - 1 + slides.length) % slides.length);

  useEffect(() => {
    const id = setInterval(next, 6000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="relative w-full h-[260px] sm:h-[360px] md:h-[460px] lg:h-[560px] overflow-hidden bg-gray-200">

      {slides.map((s, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100 z-10" : "opacity-0 z-0"
          }`}
        >
          {/* SLIDE IMAGEN */}
          {s.type === "image" && (
            <>
              <div
                className="absolute inset-0"
                style={{
                  backgroundImage: `url(${s.bg})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "right center",
                  backgroundColor: "#d1d5db",
                }}
              />

              <div className="absolute inset-0 bg-black/10" />

              <div
                className="
                  absolute top-1/2 -translate-y-1/2
                  left-[-40px] md:left-[40px]
                  w-[420px] h-[420px]
                  md:w-[560px] md:h-[560px]
                  lg:w-[650px] lg:h-[650px]
                  bg-brand-primary
                  rounded-full
                  flex items-center
                "
              >
                <div className="pl-[140px] pr-10 text-white max-w-md">
                  <h1 className="text-4xl md:text-5xl font-light leading-tight">
                    {s.title}
                    <br />
                    <span className="font-semibold">{s.highlight}</span>
                  </h1>

                  <p className="mt-4 text-sm md:text-base">
                    {s.text}
                  </p>

                  <button className="mt-6 border border-white px-6 py-2 text-sm hover:bg-white hover:text-[#ff2400] transition">
                    {s.button}
                  </button>
                </div>
              </div>
            </>
          )}

          {/* SLIDE COLOR */}
          {s.type === "solid" && (
            <div
              className="w-full h-full flex items-center justify-center px-6"
              style={{ backgroundColor: s.bgColor }}
            >
              <h2 className="text-white text-3xl md:text-5xl font-bold max-w-3xl text-center">
                {s.textBig}
              </h2>
            </div>
          )}
        </div>
      ))}

      {/* FLECHAS */}
      <button
        onClick={prev}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/70 hover:bg-white px-3 py-2"
      >
        ‹
      </button>

      <button
        onClick={next}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/70 hover:bg-white px-3 py-2"
      >
        ›
      </button>

      {/* DOTS */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-20">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            className={`w-3 h-3 rounded-full ${
              i === index ? "bg-black" : "bg-black/40"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
